<script>

    import CategoryApi from "@shared/_api/category";
    import {mapGetters, mapState} from "vuex";


    export default {
        name: 'pb-category-base',
        data: function () {
            return {
                category: null,
                busy: false,
                loadingFilter: false,
                exportInProgress: false,
                currentPage: 1,
                sizeList: [],
                filterString: null,
                currentFilterList: [],
                count: 0,
                sortOptions: {
                    'name': {
                        'label': 'article number',
                        'logic': (a, b) => {
                            return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
                        }
                    },
                    'description': {
                        'label': 'article name',
                        'logic': (a, b) => {
                            let nameA = a.primaryDescription || a.secondaryDescription,
                                nameB = b.primaryDescription || b.secondaryDescription;

                            return nameA.localeCompare(nameB);


                        }
                    },
                    'customerNumber': {
                        'label': 'customer article number',
                        'logic': (a, b) => {
                            let nameA = a.articleNameCustomer,
                                nameB = b.articleNameCustomer;

                            return nameA.localeCompare(nameB);


                        }
                    }
                },
                currentSort: null,
                currentSortDirection: 'ASC'
            }
        },
        computed: {
            ...mapState("account", ['user']),
            ...mapGetters('account', ['hasRole', 'canRead']),
            filteredArticles: function () {
                return this.category ? this.applyFilter(this.category) : [];
            },
            filteredArticlesGroupedByCategory: function () {
                if (this.category) {
                    var result = [];
                    var categoryMap = {};
                    categoryMap[this.category.id] = this.category;

                    if (this.category.childrenCategoryList) {
                        this.category.childrenCategoryList.forEach(item => {
                            categoryMap[item.id] = item
                        });
                    }

                    this.filteredArticles.forEach(item => {
                        let representingCategory = (item.categoryId in categoryMap) ? categoryMap[item.categoryId] : Object.values(categoryMap).find(cat => item.parentCategoryIdList.includes(cat.id) && cat.id !== this.category.id);
                        if(representingCategory) {
                            let existingCategory = result.find(cat => cat.categoryId === representingCategory.id);
                            if (existingCategory) {
                                existingCategory.articles.push(item);
                            } else {
                                let categoryGroup = {
                                    categoryId: representingCategory.id,
                                    categoryName: representingCategory.webName,
                                    bannerImage: representingCategory.bannerImage,
                                    meta: representingCategory.meta,
                                    articles: [item]
                                };

                                (representingCategory.id === this.category.id) ?  result.unshift(categoryGroup) : result.push(categoryGroup);

                            }
                        }

                    });

                    result.sort(function(a, b) {
                        var orderA = a.meta ? a.meta.order : 0;
                        var orderB = b.meta ? b.meta.order : 0;
                        return orderA - orderB;
                    });

                    return result;

                }
                return [];
            },
            breadcrumbs: function () {
                return [{
                    text: this.category.webName || this.category.name,
                    href: '#'
                }];
            },
            activeFilterItems: function () {
                return this.currentFilterList.filter(filterEl => {
                    let activeItems = filterEl.items.filter(filterItem => filterItem['active']);

                    return activeItems && activeItems.length > 0;
                });
            },
            visibleArticleList: function () {
                let filteredArticleList = this.filteredArticles;

                if (this.currentSort && this.sortOptions[this.currentSort]) {
                    filteredArticleList.sort(this.sortOptions[this.currentSort].logic)
                } else {
                    filteredArticleList.sort((a, b) => {

                        let referenceDate = new Date();
                        referenceDate.setDate(referenceDate.getDate() - 90);


                        let changedA = (a.lastPriceUpdateCustomer || a.lastPriceUpdate);
                        let changedB = (b.lastPriceUpdateCustomer || b.lastPriceUpdate);

                        let cA = (changedA && new Date(changedA) > referenceDate) || false;
                        let cB = (changedB && new Date(changedB) > referenceDate) || false;


                        return cB - cA;
                    });
                }

                if (this.currentSortDirection === 'DESC') {
                    filteredArticleList.reverse();
                }

                return filteredArticleList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
            },
            sort: function () {
                return this.currentSort ? this.currentSort : 'name';
            }
        },
        methods: {
            applyFilter(category, ignoreVisibility) {
                let filteredList = category ? category.articleList.filter(article => {

                    let hasImage = (article.webImage || article.image),
                        includeByFilter = true,
                        includeByVisiblitySetting = true;

                    if (this.filterString) {
                        let articleDescription = article.primaryDescription || article.secondaryDescription;

                        let includeByName = article.name ? article.name.toLowerCase().indexOf(this.filterString.toLowerCase()) > -1 : false,
                            includeByNameCustomer = article.articleNameCustomer ? article.articleNameCustomer.toLowerCase().indexOf(this.filterString.toLowerCase()) > -1 : false,
                            includeByNameUser = article.articleNameUser ? article.articleNameUser.toLowerCase().indexOf(this.filterString.toLowerCase()) > -1 : false,
                            includeByDescription = articleDescription ? articleDescription.toLowerCase().indexOf(this.filterString.toLowerCase()) > -1 : false;

                        includeByFilter = includeByName || includeByNameCustomer || includeByNameUser || includeByDescription;
                    } else if ((!this.activeFilterItems || this.activeFilterItems.length === 0) && !ignoreVisibility) {
                        includeByVisiblitySetting = article.visibleInCategory;
                    }

                    return hasImage && includeByFilter && includeByVisiblitySetting;
                }) : [];

                return filteredList;
            },
            linkGen(pageNum) {
                return this.$router.resolve({name: 'customer', query: {...this.$route.query, page: pageNum,}}).href
            },
            fetchFilter(id, queryparam) {
                CategoryApi.categoryFilterList(id).then(filterList => {
                    this.currentFilterList = [];

                    filterList.forEach(filterEl => {
                        if (this.filterConfig.includes(filterEl.key) && filterEl.items && filterEl.items.length > 0) {
                            filterEl.items.forEach(filterItem => {
                                filterItem['active'] = queryparam[filterEl.key] && String(queryparam[filterEl.key]) === String(filterItem.value);
                            });
                            this.currentFilterList.push(filterEl);
                        }
                    });

                });
            },
            onFilter(value) {
                this.filterString = value;
            },
            openSidebar() {
                this.$refs.sidebar.open();
            },
            parseQueryParams(query) {
                if (query.page) {
                    this.currentPage = parseInt(query.page);
                } else {
                    this.currentPage = 1;
                }

                if (query.sort) {
                    this.currentSort = query.sort;
                }

                if (query.sortDirection) {
                    this.currentSortDirection = query.sortDirection;
                }
            }
        },
        created() {
            this.parseQueryParams(this.$route.query);
            this.fetchCategory(this.$route.params.id, this.$route.query);
        },
        beforeRouteUpdate(to, from, next) {
            this.exportInProgress = false;
            this.parseQueryParams(to.query);
            this.fetchCategory(to.params.id, to.query);
            next();
        }
    }
</script>
